import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import "./index.scss";

export function HomePageMobileTimeSheet() {
  const [time, setTime] = useState(new Date().toLocaleTimeString());
  const history = useHistory();

  setInterval(() => {
    setTime(new Date().toLocaleTimeString());
  }, 1000);

  function handleHistoryClick() {
    history.push("timesheet/history");
  }

  function handleFormClick() {
    history.push("timesheet/form");
  }

  return (
    <>
      <div className="flex flex-col -m-4 h-full">
        <div className="h-28 w-full">_</div>
        <div className="mt-4 flex flex-col justify-between m-8 gap-16 h-full">
          <div className="h-3/5">
            <div className="flex-col mt-16 items-center justify-center bg-primary rounded-full header-mobile-timesheet-homepage w-full shadow-xl ">
              <div className="flex flex-col justify-evenly h-full text-center py-12">
                <h1 className="font-familyPoppins text-9xl mb-16">{time}</h1>
                <p className="flex flex-col">
                  <span className="text-5xl font-normal mb-8"> {new Date().toLocaleDateString("pt-br", { weekday: "long" })}</span>
                  <span className="text-5xl font-normal">
                    {" "}
                    {new Date().toLocaleDateString("pt-br", { day: "2-digit", month: "long", year: "numeric" })}
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="h-2/5 flex flex-col justify-center text-center text-textPrimary font-semibold font-familyPoppins gap-8">
            <h2 className="text-5xl">Bem-vindo</h2>
            <p className="text-4xl">ao marcador de ponto do InTegra!</p>
          </div>
          <div className="flex w-full justify-between">
            <button className="bg-secondary h-20 rounded-3xl w-2/5 text-2rem font-familyPoppins font-medium shadow-2xl" onClick={handleHistoryClick}>
              Histórico
            </button>
            <button className="bg-primary h-20 rounded-3xl w-2/5 text-2rem font-familyPoppins font-medium shadow-2xl" onClick={handleFormClick}>
              Entrar
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

// get current browser
